<template>
  <div class="general-reports">
    <div class="reports-table-wrap">
      <table class="reports-table">
        <thead>
          <tr>
            <th class="reports-table__th reports-table__th--name">Отчёт</th>
            <th class="reports-table__th reports-table__th--params">Параметры</th>
            <th class="reports-table__th reports-table__th--action">Действие</th>
          </tr>
        </thead>
        <tbody>
          <!-- Клиенты: период + Скачать -->
          <tr class="reports-table__row">
            <td class="reports-table__cell reports-table__cell--name">Получение информации о клиентах</td>
            <td class="reports-table__cell reports-table__cell--params">
              <v-menu
                v-model="menuClient"
                :close-on-content-click="false"
                offset-y
                transition="scale-transition"
                min-width="190px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateRangeClient"
                    label="Промежуток времени"
                    outlined
                    dense
                    hide-details
                    class="reports-table__field"
                    v-on="on"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                  />
                </template>
                <v-date-picker v-model="dateClient" range @click="menuClient = false">
                  <v-spacer />
                  <v-btn text color="primary" @click="menuClient = false">Назад</v-btn>
                  <v-btn text color="primary" :disabled="!dateClient[0]" @click="dateClient = []">Сбросить</v-btn>
                  <v-btn text color="primary" @click="menuClient = false">Выбрать</v-btn>
                </v-date-picker>
              </v-menu>
            </td>
            <td class="reports-table__cell reports-table__cell--action">
              <v-btn
                :disabled="!dateClient[1]"
                color="primary"
                class="text-none"
                dark
                rounded
                small
                @click="downloadClient"
              >
                <v-icon left small>mdi-download-outline</v-icon>
                Скачать
              </v-btn>
            </td>
          </tr>

          <!-- Абоненты: период + Скачать -->
          <tr class="reports-table__row">
            <td class="reports-table__cell reports-table__cell--name">Получение информации об абонентах</td>
            <td class="reports-table__cell reports-table__cell--params">
              <v-menu
                v-model="menuSubscriber"
                :close-on-content-click="false"
                offset-y
                transition="scale-transition"
                min-width="190px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateRangeSubscriber"
                    label="Промежуток времени"
                    outlined
                    dense
                    hide-details
                    class="reports-table__field"
                    v-on="on"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                  />
                </template>
                <v-date-picker v-model="dateSubscriber" range @click="menuSubscriber = false">
                  <v-spacer />
                  <v-btn text color="primary" @click="menuSubscriber = false">Назад</v-btn>
                  <v-btn text color="primary" :disabled="!dateSubscriber[0]" @click="dateSubscriber = []">Сбросить</v-btn>
                  <v-btn text color="primary" @click="menuSubscriber = false">Выбрать</v-btn>
                </v-date-picker>
              </v-menu>
            </td>
            <td class="reports-table__cell reports-table__cell--action">
              <v-btn
                :disabled="!dateSubscriber[1]"
                color="primary"
                class="text-none"
                dark
                rounded
                small
                @click="downloadSubscriber"
              >
                <v-icon left small>mdi-download-outline</v-icon>
                Скачать
              </v-btn>
            </td>
          </tr>

          <!-- Лицевые счета: только Скачать -->
          <tr class="reports-table__row">
            <td class="reports-table__cell reports-table__cell--name">Получение информации о всех лицевых счетах (домофонов)</td>
            <td class="reports-table__cell reports-table__cell--params">
              <span class="reports-table__hint">—</span>
            </td>
            <td class="reports-table__cell reports-table__cell--action">
              <v-btn color="primary" class="text-none" dark rounded small @click="downloadPersonalAccount">
                <v-icon left small>mdi-download-outline</v-icon>
                Скачать
              </v-btn>
            </td>
          </tr>

          <!-- SIP статусы: два датапикера + Просмотр -->
          <tr class="reports-table__row">
            <td class="reports-table__cell reports-table__cell--name">Просмотр статистики sip статусов</td>
            <td class="reports-table__cell reports-table__cell--params">
              <div class="reports-table__datetime-row">
                <v-datetime-picker
                  label="Дата и время начала"
                  :text-field-props="sipTextFieldProps"
                  :time-picker-props="sipTimeProps"
                  v-model="datetimeStart"
                  class="reports-table__field-sip"
                >
                  <template v-slot:dateIcon><v-icon>mdi-calendar</v-icon></template>
                  <template v-slot:timeIcon><v-icon>mdi-clock-time-four-outline</v-icon></template>
                  <template v-slot:actions="{ parent }">
                    <v-btn text color="primary" :disabled="!datetimeStart" @click.native="parent.clearHandler">Сбросить</v-btn>
                    <v-btn text color="primary" @click="parent.okHandler">Выбрать</v-btn>
                  </template>
                </v-datetime-picker>
                <v-datetime-picker
                  label="Дата и время завершения"
                  :text-field-props="sipTextFieldProps"
                  :time-picker-props="sipTimeProps"
                  v-model="datetimeEnd"
                  class="reports-table__field-sip"
                >
                  <template v-slot:dateIcon><v-icon>mdi-calendar</v-icon></template>
                  <template v-slot:timeIcon><v-icon>mdi-clock-time-four-outline</v-icon></template>
                  <template v-slot:actions="{ parent }">
                    <v-btn text color="primary" :disabled="!datetimeEnd" @click.native="parent.clearHandler">Сбросить</v-btn>
                    <v-btn text color="primary" @click="parent.okHandler">Выбрать</v-btn>
                  </template>
                </v-datetime-picker>
              </div>
            </td>
            <td class="reports-table__cell reports-table__cell--action">
              <v-btn
                :disabled="!datetimeEnd || !datetimeStart"
                :loading="sipLoading"
                color="primary"
                class="text-none"
                dark
                rounded
                small
                @click="viewSipStatus"
              >
                <v-icon left small>mdi-eye-outline</v-icon>
                Просмотр
              </v-btn>
            </td>
          </tr>

          <!-- Аудиозаписи открытия двери -->
          <tr class="reports-table__row">
            <td class="reports-table__cell reports-table__cell--name">Получение списка загрузок аудизаписей «открытия двери»</td>
            <td class="reports-table__cell reports-table__cell--params">
              <span class="reports-table__hint">—</span>
            </td>
            <td class="reports-table__cell reports-table__cell--action">
              <v-btn color="primary" class="text-none" dark rounded small @click="getAudioUpload">
                <v-icon left small>mdi-eye-outline</v-icon>
                Просмотр
              </v-btn>
            </td>
          </tr>

          <!-- LCD изображения -->
          <tr class="reports-table__row">
            <td class="reports-table__cell reports-table__cell--name">Получение списка загрузок LCD-изображений</td>
            <td class="reports-table__cell reports-table__cell--params">
              <span class="reports-table__hint">—</span>
            </td>
            <td class="reports-table__cell reports-table__cell--action">
              <v-btn color="primary" class="text-none" dark rounded small @click="getLcdUpload">
                <v-icon left small>mdi-eye-outline</v-icon>
                Просмотр
              </v-btn>
            </td>
          </tr>

          <!-- Домофоны с ненастроенной камерой -->
          <tr class="reports-table__row">
            <td class="reports-table__cell reports-table__cell--name">Получение списка домофонов с ненастроенной камерой</td>
            <td class="reports-table__cell reports-table__cell--params">
              <span class="reports-table__hint">—</span>
            </td>
            <td class="reports-table__cell reports-table__cell--action">
              <v-btn color="primary" class="text-none" dark rounded small @click="getInfoCameras">
                <v-icon left small>mdi-eye-outline</v-icon>
                Просмотр
              </v-btn>
            </td>
          </tr>

          <!-- Информация о квартирах -->
          <tr class="reports-table__row">
            <td class="reports-table__cell reports-table__cell--name">Получение информации о квартирах</td>
            <td class="reports-table__cell reports-table__cell--params">
              <span class="reports-table__hint">—</span>
            </td>
            <td class="reports-table__cell reports-table__cell--action">
              <v-btn color="primary" class="text-none" dark rounded small @click="downloadApartment">
                <v-icon left small>mdi-download-outline</v-icon>
                Скачать
              </v-btn>
            </td>
          </tr>

          <!-- Полный отчёт о домофонах -->
          <tr class="reports-table__row">
            <td class="reports-table__cell reports-table__cell--name">Получение полного отчёта о домофонах</td>
            <td class="reports-table__cell reports-table__cell--params">
              <span class="reports-table__hint">—</span>
            </td>
            <td class="reports-table__cell reports-table__cell--action">
              <v-btn color="primary" class="text-none" dark rounded small @click="downloadFullReportDoorphone">
                <v-icon left small>mdi-download-outline</v-icon>
                Скачать
              </v-btn>
            </td>
          </tr>

          <!-- Статистика сервисного кода -->
          <tr
            v-if="$checkPermission('get_service_door_code_stats')"
            class="reports-table__row"
          >
            <td class="reports-table__cell reports-table__cell--name">
              Статистика сервисного кода
              <div class="reports-table__hint mt-1">
                Домофоны с кодами 1234 / 1111 / 12345 и открытия сервисным кодом за период
              </div>
            </td>
            <td class="reports-table__cell reports-table__cell--params">
              <v-btn-toggle
                v-model="serviceDoorCodeDays"
                mandatory
                dense
                rounded
                color="primary"
                class="reports-table__days-toggle"
              >
                <v-btn
                  v-for="option in serviceDoorCodeDayOptions"
                  :key="option"
                  :value="option"
                  small
                  class="text-none"
                >
                  {{ option }} дн.
                </v-btn>
              </v-btn-toggle>
            </td>
            <td class="reports-table__cell reports-table__cell--action">
              <v-btn
                color="primary"
                class="text-none"
                dark
                rounded
                small
                :loading="serviceDoorCodeStatsLoading"
                @click="downloadServiceDoorCodeStats"
              >
                <v-icon left small>mdi-download-outline</v-icon>
                Скачать
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <LoadingAudioDoorOpen
      :dialog="dialogAudioUpload"
      :media-type="mediaUploadType"
      :total-journal.sync="totalJournal"
      :loading-audio-upload="loadingAudioUpload"
      @close="dialogAudioUpload = false"
    />
    <v-dialog v-model="dialogCheckCameras" max-width="1050">
      <CheckCamerasNavy :cameras="cameras" />
    </v-dialog>
    <v-dialog v-model="dialogSip" :max-width="isMobile ? '90%' : 'max-content'">
      <ViewSipStatistics
        :statistics="selectedStatistics"
        :SipStatusLogs="selectedSipStatusLogs"
        :propsEndTime="propsEndTime"
        :propsStartTime="propsStartTime"
        :propsDateSip="propsDateSip"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import CheckCamerasNavy from '@/components/reports/components/CheckCamerasNavy';
import ViewSipStatistics from '@/components/reports/components/ViewSipStatistics';
import LoadingAudioDoorOpen from '@/components/reports/components/LoadingAudioDoorOpen';

export default {
  name: 'BaseGeneralReports',
  components: {
    LoadingAudioDoorOpen,
    CheckCamerasNavy,
    ViewSipStatistics,
  },
  data () {
    return {
      menuClient: false,
      menuSubscriber: false,
      dateClient: [],
      dateSubscriber: [],
      datetimeStart: '',
      datetimeEnd: '',
      sipTextFieldProps: {
        dense: 'dense',
        hideDetails: 'hideDetails',
        readonly: 'readonly',
        outlined: 'outlined',
      },
      sipTimeProps: { format: '24hr', ampmInTitle: true },
      sipLoading: false,
      dialogSip: false,
      isMobile: false,
      selectedStatistics: [],
      selectedSipStatusLogs: [],
      propsStartTime: '',
      propsEndTime: '',
      propsDateSip: [],
      dialogAudioUpload: false,
      loadingAudioUpload: false,
      mediaUploadType: 'audio',
      dialogCheckCameras: false,
      totalJournal: 0,
      cameras: [],
      serviceDoorCodeDays: 3,
      serviceDoorCodeDayOptions: [3, 5, 7],
      serviceDoorCodeStatsLoading: false,
    };
  },
  computed: {
    dateRangeClient () {
      return (this.dateClient || []).join(' — ');
    },
    dateRangeSubscriber () {
      return (this.dateSubscriber || []).join(' — ');
    },
  },
  mounted () {
    this.isMobile = window.innerWidth < 600;
  },
  methods: {
    ...mapActions({
      downloadListClient: 'Reports/downloadListClient',
      downloadSubscriberReport: 'Reports/downloadSubscriber',
      downloadPersonalAccountForm: 'Reports/downloadPersonalAccountForm',
      downloadApartmentForm: 'Reports/downloadApartmentForm',
      downloadFullReportFormDoorphone: 'Reports/downloadFullReportFormDoorphone',
      downloadServiceDoorCodeStatsReport: 'Reports/downloadServiceDoorCodeStats',
      audioUpload: 'Doorphone/audioUpload',
      getCheckCameras: 'Doorphone/getCheckCameras',
      sipStatistics: 'Doorphone/sipStatistics',
      getSipStatusLogs: 'Doorphone/getSipStatusLogs',
    }),
    downloadClient () {
      this.downloadListClient({
        dateTo: this.dateClient[0],
        dateFrom: this.dateClient[1],
      })
        .then((response) => {
          const a = document.createElement('a');
          a.download = 'client-form.csv';
          a.href = URL.createObjectURL(new Blob([response], { type: 'application/csv' }));
          a.click();
        })
        .catch(() => this.$flash_warning('Не удалось скачать список клиентов без абонентов'));
    },
    downloadSubscriber () {
      this.downloadSubscriberReport({
        dateTo: this.dateSubscriber[0],
        dateFrom: this.dateSubscriber[1],
      })
        .then((response) => {
          const a = document.createElement('a');
          a.download = 'subscriber-form.csv';
          a.href = URL.createObjectURL(new Blob([response], { type: 'application/csv' }));
          a.click();
        })
        .catch(() => this.$flash_warning('Не удалось скачать информацию об абонентах'));
    },
    downloadPersonalAccount () {
      this.downloadPersonalAccountForm()
        .then((response) => {
          const a = document.createElement('a');
          a.download = 'personal-accounts-form.csv';
          a.href = URL.createObjectURL(new Blob([response], { type: 'application/csv' }));
          a.click();
        })
        .catch(() => this.$flash_warning('Не удалось скачать информацию о лицевых счетах'));
    },
    viewSipStatus () {
      const timeEnd = this.datetimeEnd.toISOString();
      const timeStart = this.datetimeStart.toISOString();
      const localDateStart = moment.utc(timeStart).local();
      const localDateEnd = moment.utc(timeEnd).local();
      const dateTo = localDateStart.format('YYYY-MM-DD HH:mm:ss');
      const dateFrom = localDateEnd.format('YYYY-MM-DD HH:mm:ss');
      this.sipLoading = true;
      this.sipStatistics({ dateTo, dateFrom })
        .then((data) => {
          this.sipLoading = false;
          this.selectedStatistics = data.data;
          this.propsStartTime = dateTo;
          this.propsEndTime = dateFrom;
          this.propsDateSip = [];
          this.dialogSip = true;
        })
        .catch(() => {
          this.$flash_warning('Не удалось получить статистику sip статусов');
          this.sipLoading = false;
        });
      this.getSipStatusLogs({ dateTo, dateFrom }).then((data) => {
        this.selectedSipStatusLogs = data.data;
      });
    },
    async getInfoCameras () {
      try {
        const response = await this.getCheckCameras();
        this.cameras = response.wrong_mac_addresses || [];
        this.dialogCheckCameras = true;
      } catch {
        this.$flash_warning('Ошибка при загрузке');
      }
    },
    async getAudioUpload () {
      this.mediaUploadType = 'audio';
      this.loadingAudioUpload = true;
      try {
        const response = await this.audioUpload({
          options: { page: 1, limit: 20, media_type: 'audio' },
        });
        this.totalJournal = response.meta?.total || 0;
        this.dialogAudioUpload = true;
      } catch {
        this.$flash_warning('Ошибка при загрузке списка загрузок аудио');
      } finally {
        this.loadingAudioUpload = false;
      }
    },
    async getLcdUpload () {
      this.mediaUploadType = 'lcd';
      this.loadingAudioUpload = true;
      try {
        const response = await this.audioUpload({
          options: { page: 1, limit: 20, media_type: 'lcd' },
        });
        this.totalJournal = response.meta?.total || 0;
        this.dialogAudioUpload = true;
      } catch {
        this.$flash_warning('Ошибка при загрузке списка загрузок изображений');
      } finally {
        this.loadingAudioUpload = false;
      }
    },
    downloadApartment () {
      this.downloadApartmentForm()
        .then((response) => {
          const a = document.createElement('a');
          a.download = 'apartment-form.csv';
          a.href = URL.createObjectURL(new Blob([response], { type: 'application/csv' }));
          a.click();
        })
        .catch(() => this.$flash_warning('Не удалось скачать информацию о квартирах'));
    },
    downloadFullReportDoorphone () {
      this.downloadFullReportFormDoorphone()
        .then((response) => {
          const a = document.createElement('a');
          a.download = 'full-doorphone-form.csv';
          a.href = URL.createObjectURL(new Blob([response], { type: 'application/csv' }));
          a.click();
        })
        .catch(() => this.$flash_warning('Не удалось скачать полный отчёт о домофонах'));
    },
    downloadServiceDoorCodeStats () {
      this.serviceDoorCodeStatsLoading = true;
      this.downloadServiceDoorCodeStatsReport({ days: this.serviceDoorCodeDays })
        .then((response) => {
          const a = document.createElement('a');
          a.download = `service-door-code-stats-${this.serviceDoorCodeDays}d.csv`;
          a.href = URL.createObjectURL(new Blob([response], { type: 'application/csv' }));
          a.click();
        })
        .catch(() => this.$flash_warning('Не удалось скачать статистику сервисного кода'))
        .finally(() => {
          this.serviceDoorCodeStatsLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.reports-table-wrap {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.reports-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9375rem;
}

.reports-table__th {
  text-align: left;
  padding: 12px 16px;
  font-weight: 600;
  color: #546e7a;
  background: #f5f7f8;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  white-space: nowrap;
}

.reports-table__th--name {
  min-width: 260px;
  width: 40%;
}

.reports-table__th--params {
  min-width: 200px;
  width: 35%;
}

.reports-table__th--action {
  min-width: 140px;
  width: 25%;
}

.reports-table__row {
  transition: background-color 0.15s;
}

.reports-table__row:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.reports-table__row:not(:last-child) .reports-table__cell {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.reports-table__cell {
  padding: 12px 16px;
  vertical-align: middle;
  color: #37474f;
}

.reports-table__cell--name {
  font-weight: 500;
  color: #37474f;
}

.reports-table__cell--params {
  min-width: 0;
}

.reports-table__field {
  max-width: 260px;
}

.reports-table__field ::v-deep .v-input__control {
  min-height: 40px;
}

.reports-table__datetime-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.reports-table__field-sip {
  max-width: 240px;
}

.reports-table__hint {
  color: #90a4ae;
  font-size: 0.875rem;
  font-weight: 400;
}

.reports-table__days-toggle {
  flex-wrap: wrap;
}
</style>
